<script>
  import PageWrapper from "@src/components/PageWrapper.svelte";
  import Row from "@src/components/Row.svelte";
</script>

<svelte:head>
  <title>Niilon Pojat - Jäsenedut</title>
</svelte:head>
<PageWrapper fillerColor="gray">
  <Row color="yellow">
    <h1>Jäsenedut kaudella 2026</h1>
    <ul>
      <li>
        <strong>Kannattajamatkat</strong> alennettuun hintaan
      </li>
      <li>
        <strong>Vieraskausikortti</strong> alennettuun hintaan
      </li>
    </ul>
  </Row>
  <Row color="gray" filler />
</PageWrapper>

<style>
  ul {
    line-height: 1.5;
  }

  li {
    margin: 1rem;
  }
</style>
